var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ApplicationContext } from '../../../../ApplicationContext';
import LabelSearch from '../../../components/ui/LabelSearch/LabelSearch';
import AddAssetLabelCommand from '../../../../commands/labels/AddAssetLabelCommand';
import Label from '../../../components/ui/Label/Label';
import DeleteAssetLabelCommand from '../../../../commands/labels/DeleteAssetLabelCommand';
import { Link } from 'react-router-dom';
import Routes from '../../../../routes/RoutesConfig';
import Signals from '../../../../signals/Signals';
import GetOrganisationLabelsCommand from '../../../../commands/labels/GetOrganisationLabelsCommand';
import LabelOverlay from '../../Labels/LabelOverlay';
import LabelModel from '../../../../models/LabelModel';
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
var AssetDetailLabels = /** @class */ (function (_super) {
    __extends(AssetDetailLabels, _super);
    /**
     *
     * @param props
     */
    function AssetDetailLabels(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { labelSearchVisible: false };
        _this.onRemoveLabel = _this.onRemoveLabel.bind(_this);
        _this.onAddLabel = _this.onAddLabel.bind(_this);
        _this.onLabelModelAdded = _this.onLabelModelAdded.bind(_this);
        return _this;
    }
    /**
     *
     */
    AssetDetailLabels.prototype.componentDidMount = function () {
        var session = this.context.session;
        var labelCollection = this.context.labelCollection;
        var command = new GetOrganisationLabelsCommand();
        command.execute(session.user.organisation.id, labelCollection);
        Signals.LabelModelAdded.add(this.onLabelModelAdded);
    };
    /**
     *
     */
    AssetDetailLabels.prototype.componentWillUnmount = function () {
        Signals.LabelModelAdded.remove(this.onLabelModelAdded);
    };
    /**
     *
     * @return {*}
     */
    AssetDetailLabels.prototype.render = function () {
        var _this = this;
        var assetModel = this.props.assetModel;
        var labelSearchVisible = this.state.labelSearchVisible;
        return (React.createElement("div", { className: "w-100" },
            React.createElement("hr", null),
            React.createElement("div", { className: 'w-100 d-flex align-items-start justify-content-between' + (labelSearchVisible ? ' flex-wrap' : '') },
                assetModel.labels.length > 0 ?
                    React.createElement("div", { className: "d-flex flex-wrap w-100" }, assetModel.labels.map(function (labelModel, index) {
                        if (labelModel) {
                            return React.createElement(Label, { key: index + '-' + labelModel.id, className: "d-inline mr-2 mt-1", model: labelModel, onRemove: labelSearchVisible ? _this.onRemoveLabel : null });
                        }
                    })) :
                    React.createElement("div", { className: "text-muted" },
                        React.createElement(FormattedMessage, { id: "label.empty" })),
                React.createElement(LabelSearch, { exclude: assetModel.labels.concat([]), onChange: this.onAddLabel, onVisibility: function (visible) {
                        _this.setState(({ labelSearchVisible: visible }));
                    } })),
            labelSearchVisible ?
                React.createElement("div", { className: "d-flex" },
                    React.createElement("div", { className: "btn-link mt-3 mr-3 cursor-pointer", onClick: function () {
                            Signals.ShowOverlay.dispatch((React.createElement(LabelOverlay, { labelModel: new LabelModel() })));
                        } },
                        React.createElement("i", { className: "fe fe-plus-circle" }),
                        " ",
                        React.createElement(FormattedMessage, { id: "page.labels.addlabel" })),
                    React.createElement("div", { className: "d-flex mt-3" },
                        React.createElement(Link, { to: Routes.LABELS.getPath(), onClick: function () {
                                Signals.HideOverlay.dispatch();
                                Signals.HideAssetDetail.dispatch();
                            } },
                            React.createElement("i", { className: "fe fe-edit-2" }),
                            " ",
                            React.createElement(FormattedMessage, { id: "filters.labels.edit" })))) : null));
    };
    /**
     *
     * @param labelModel
     */
    AssetDetailLabels.prototype.onRemoveLabel = function (labelModel) {
        var _this = this;
        if (labelModel) {
            var assetModel_1 = this.props.assetModel;
            var _a = this.context, session = _a.session, assetCollection_1 = _a.assetCollection;
            var command = new DeleteAssetLabelCommand();
            command.execute(labelModel.id, assetModel_1.getAssetSerial(), session.user.organisation.id).finally(function () {
                var labels = assetModel_1.labels.concat([]);
                for (var i = labels.length - 1; i >= 0; i--) {
                    if (labels[i] && labelModel) {
                        if (labels[i].id === labelModel.id) {
                            labels.splice(i, 1);
                        }
                    }
                }
                // trigger update
                assetModel_1.labels = labels;
                _this.forceUpdate();
                assetCollection_1.update();
            });
        }
    };
    /**
     *
     * @param labelModel
     */
    AssetDetailLabels.prototype.onAddLabel = function (labelModel) {
        var _this = this;
        if (labelModel) {
            var _a = this.context, session = _a.session, assetCollection_2 = _a.assetCollection;
            var assetModel_2 = this.props.assetModel;
            var command = new AddAssetLabelCommand();
            command.execute(labelModel.id, assetModel_2.getAssetSerial(), session.user.organisation.id).then(function () {
                assetModel_2.labels.push(labelModel);
                assetModel_2.labels = assetModel_2.labels.concat([]);
                _this.forceUpdate();
                assetCollection_2.update();
            });
        }
    };
    /**
     *
     * @param labelModel
     */
    AssetDetailLabels.prototype.onLabelModelAdded = function (labelModel) {
        this.onAddLabel(labelModel);
    };
    AssetDetailLabels.defaultProps = {
        className: ''
    };
    return AssetDetailLabels;
}(React.Component));
AssetDetailLabels.contextType = ApplicationContext;
export default injectIntl(AssetDetailLabels);
